import {put, takeEvery} from "redux-saga/effects";
import {Design} from "../../../Models/Design";
import {DesignExample} from "../../../Models/DesignExample";
import {
    designExampleCreateError,
    designExampleCreateSuccess,
    designExampleLoadError,
    designExampleLoadSuccess,
    designExamplesGetError,
    designExamplesGetSuccess,
    designExampleUpdateError,
    designExampleUpdateSuccess,
    designsGetError,
    designsGetSuccess,
} from "./actions";
import * as TYPES from "./types";

export default function* designsSagas() {
    yield takeEvery(TYPES.DESIGNS_GET_REQUEST, designsGetRequest);

    yield takeEvery(TYPES.DESIGN_EXAMPLES_GET_REQUEST, designExamplesGetRequest);
    yield takeEvery(TYPES.DESIGN_EXAMPLE_LOAD_REQUEST, designExampleLoadRequest);
    yield takeEvery(TYPES.DESIGN_EXAMPLE_CREATE_REQUEST, designExampleCreateRequest);
    yield takeEvery(TYPES.DESIGN_EXAMPLE_UPDATE_REQUEST, designExampleUpdateRequest);
}

function* designsGetRequest(action) {
    try {
        const response = yield Design.index({
            ...action.payload,
        });

        yield put(
            designsGetSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(designsGetError(error));
    }
}

function* designExamplesGetRequest(action) {
    try {
        const response = yield DesignExample.index({
            ...action.payload,
        });

        yield put(
            designExamplesGetSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(designExamplesGetError(error));
    }
}

function* designExampleLoadRequest(action) {
    try {
        const response = yield DesignExample.find(action.payload);

        yield put(
            designExampleLoadSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(designExampleLoadError(error));
    }
}

function* designExampleCreateRequest(action) {
    try {
        const response = yield DesignExample.create(action.payload);

        yield put(
            designExampleCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(designExampleCreateError(error));
    }
}

function* designExampleUpdateRequest(action) {
    try {
        const response = yield DesignExample.update(action.payload.id, action.payload);

        yield put(
            designExampleUpdateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(designExampleUpdateError(error));
    }
}
